




















































import { MyChartVue } from "fs-pb-vue2/vueModels/app/MyChartVue";
import { Component } from "vue-property-decorator";

@Component({})
export default class MyChart extends MyChartVue {
  toggleChart(): void {
    this.$emit('chartToggle', { isShow: this.isChartHidden })
  }

  mounted() {
    /** Вызов рендера диаграммы при наличии входных данных */
    if (this.inputData !== undefined && this.inputData.length > 0) {
      this.chartRender();
    }
  }
  beforeDestroy() {
    this.chart.dispose();
  }
}
